import React from "react";
import { Helmet } from "react-helmet-async";

import { COURSE } from "../../../Helpers/Enums";

const SeoComponent = ({ title, description, route }) => {
  const trimDescription = () => {
    if (description?.length > COURSE.CONSTANTS.SHORT_DESCRIPTION_MAX) {
      return description.slice(0, 160);
    }

    return description; // If it doesn't need trimming
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={trimDescription()} />
      <link rel="canonical" href={route} />
    </Helmet>
  );
};

export default SeoComponent;
